import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "api/axiosService";

function Project(props) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [listNews, setListNews] = useState([]);
  const [settingInfo, setSettingInfo] = useState({});
  useEffect(() => {
    fetchData();
    getNewsBanner();
  }, []);
  const getNewsBanner = async () => {
    try {
      const response = await axiosInstance.get("/api/setting/info");

      setSettingInfo(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Xử lý lỗi tại đây
    }
  };
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/api/news/list?limit=100");
      let tempArtists = [];
      response.data.data.forEach((ele) => {
        tempArtists.push({
          title_VN: ele.title_VN,
          title_ENG: ele.title_ENG,
          content_ENG: ele.content_ENG,
          content_VN: ele.content_VN,
          url: ele.url,
          content: ele.content,
          image: ele.image,
        });
      });
      setListNews(tempArtists);
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Xử lý lỗi tại đây
    }
  };

  return (
    <div className="project">
      <div className="main">
        <div className="title">{t("DỰ ÁN")}</div>
        <div className="image-project">
          {settingInfo.news_banner ? (
            <img alt="ssg" src={settingInfo.news_banner} />
          ) : (
            <span></span>
          )}
        </div>
        <div className="topic">
          <div className="title">{t("PROJECT-1")}</div>
          <div className="content">
            {i18n.language == "vi"
              ? settingInfo.news_content_VN
              : settingInfo.news_content_ENG}
          </div>
        </div>
        <div className="list-project">
          <div className="title">{t("DANH SÁCH DỰ ÁN")}</div>
          <div className="list">
            {listNews.map((ele) => (
              <div
                className="item-project"
                onClick={() => window.open(ele.url, "_blank")}
              >
                <img className="new-image" alt="ssg" src={ele.image} />
                <div className="title-item">
                  <h1 className="project-title">
                    {i18n.language === "vi" ? ele.title_VN : ele.title_ENG}
                  </h1>
                  <div className="brief-intro">
                    {i18n.language === "vi" ? ele.content_VN : ele.content_ENG}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
